const article = {
    slug: "junya-watanabe",
    category: "BRAND BUYBACK",
    listTitle: "JUNYA WATANABE買取",
    listDescription:
      "MAN・eYe・コラボレーション作品まで、ジュンヤワタナベの構造性と市場価値を見て査定する専用買取ページ。",
    seo: {
      title:
        "ジュンヤワタナベ買取｜JUNYA WATANABE MAN・eYe・コラボまで査定するEnclopedia",
      description:
        "JUNYA WATANABE（ジュンヤワタナベ）の買取ならEnclopediaへ。JUNYA WATANABE MAN、eYe JUNYA WATANABE MAN、コムデギャルソン期、パッチワーク・再構築・デニム・コラボレーション品まで、背景と需要を見て査定。LINE事前査定から全国対応の宅配買取へご案内します。",
      keyword:
        "ジュンヤワタナベ 買取,JUNYA WATANABE 買取,ジュンヤワタナベマン 買取,JUNYA WATANABE MAN 買取,eYe JUNYA WATANABE MAN 買取,アイ ジュンヤワタナベマン 買取,コムデギャルソン ジュンヤワタナベ 買取,ジュンヤワタナベ 高価買取,ジュンヤワタナベ 宅配買取,ジュンヤワタナベ LINE査定,ジュンヤワタナベ コラボ 買取,ジュンヤワタナベ アーカイブ 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/junya-watanabe",
    },
    hero: {
      label: "JUNYA WATANABE BUYBACK",
      number: "05 / BUYBACK",
      titleLines: [
        "ジュンヤワタナベ買取。",
        "構造と背景まで見て査定します。",
      ],
      body:
        "Enclopediaは、JUNYA WATANABEをブランド名だけで一律に判断しません。\nJUNYA WATANABE MAN、eYe JUNYA WATANABE MAN、コムデギャルソン期の作品を含め、パッチワーク、再構築、異素材ミックス、デニム、コラボレーション性まで確認して査定します。\nまずはLINEで無料の事前査定。納得いただけた方を、全国対応の宅配買取へご案内します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "buyback",
        "reconstruction",
        "collaboration value",
        "junya watanabe",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: [
        "人気だけでなく、",
        "服の構造まで見る。",
      ],
      image: "media/archive_fashion/buyback5.png",
      imageAlt: "JUNYA WATANABE買取のメイン画像",
    },
    thesis: {
      text:
        "JUNYA WATANABEの価値は、ブランド名だけでなく、造形・コラボレーション・アーカイブ性まで見て判断する。",
      keywords: ["construction", "collaboration", "rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "ジュンヤワタナベの価値は、",
        "“コラボ人気”だけでは測れない。",
      ],
      body:
        "JUNYA WATANABEは、既存の服や素材に独自の解釈を加え、まったく異なる存在へ変えるデザインで評価されてきたブランドです。\nパッチワーク、再構築、デニム、立体的なカッティング、ワークやミリタリーを基盤にしたメンズウェア、そして歴史あるブランドとのコラボレーション。\nEnclopediaでは、単に人気モデルかどうかではなく、その一着がどの時期に生まれ、どのような表現を持つかまで確認して査定します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つの査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "造形と再構築性を見る",
          text:
            "パッチワーク、異素材の接続、立体裁断、解体的な切替など、JUNYA WATANABEらしい構造がどの程度表れているかを確認します。",
        },
        {
          number: "02",
          title: "ラインと年代を見る",
          text:
            "JUNYA WATANABE、JUNYA WATANABE MAN、eYe JUNYA WATANABE MAN、コムデギャルソン表記時代など、ラインと年代の違いを踏まえて判断します。",
        },
        {
          number: "03",
          title: "コラボレーション価値を見る",
          text:
            "Levi’s、THE NORTH FACE、Moncler、LOEWE、Tricker’s、New Balanceなどとの協業品は、市場需要と作品背景を確認して個別に評価します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "JUNYA WATANABE全般を、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "JUNYA WATANABE",
          text:
            "ウィメンズを中心とした本ライン。立体構造、変形ドレス、ジャケット、スカート、素材表現が強い作品を丁寧に査定します。",
        },
        {
          tag: "ITEM 02",
          title: "JUNYA WATANABE MAN",
          text:
            "ワーク、ミリタリー、テーラード、デニムを基盤にしたメンズライン。再構築性やコラボレーション性を見て判断します。",
        },
        {
          tag: "ITEM 03",
          title: "eYe JUNYA WATANABE MAN",
          text:
            "定番性と実用性の中にJUNYAらしさが表れるライン。ジャケット、パンツ、アウター、コラボ品まで査定対象です。",
        },
        {
          tag: "ITEM 04",
          title: "パッチワーク・再構築アイテム",
          text:
            "JUNYA WATANABEを象徴するパッチワークデニム、再構築ジャケット、切替コートなどは特に丁寧に確認します。",
        },
        {
          tag: "ITEM 05",
          title: "デニム・レザー・ワーク系",
          text:
            "デニムパンツ、デニムジャケット、ライダース、ワークジャケット、ミリタリー由来のアウターなどを幅広く見ます。",
        },
        {
          tag: "ITEM 06",
          title: "コラボレーション作品",
          text:
            "Levi’s、THE NORTH FACE、Moncler、LOEWE、Tricker’s、New Balanceなど、注目度の高い協業品を個別に評価します。",
        },
        {
          tag: "ITEM 07",
          title: "シューズ・バッグ・アクセサリー",
          text:
            "スニーカー、ブーツ、バッグ、小物類も、アイテム内容と市場需要に応じて査定可能です。",
        },
        {
          tag: "ITEM 08",
          title: "過去シーズンのアーカイブ",
          text:
            "年代が古いだけでなく、今も評価される作品や流通量の少ないピースはアーカイブ価値まで見ます。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "JUNYA WATANABEのアイテム。",
      ],
      intro:
        "査定額は状態や市場性で変動しますが、Enclopediaでは特に以下のようなJUNYA WATANABEを丁寧に確認します。",
      items: [
        {
          index: "01",
          title: "パッチワーク・再構築・立体造形が際立つ作品",
          text:
            "JUNYA WATANABEのデザイン性が強く現れるジャケット、パンツ、ドレス、コートは、単なる型番相場ではなく造形そのものを見ます。",
        },
        {
          index: "02",
          title: "JUNYA WATANABE MANの人気アウター・デニム",
          text:
            "メンズラインのコート、ブルゾン、ワークジャケット、パッチワークデニムは、中古市場でも評価されやすい領域です。",
        },
        {
          index: "03",
          title: "Levi’s・THE NORTH FACEなどのコラボレーション",
          text:
            "歴史あるブランドとの協業品は、通常ラインとは異なる需要を持つため、発売時期・仕様・現在需要を踏まえて個別に見ます。",
        },
        {
          index: "04",
          title: "eYe JUNYA WATANABE MANの人気モデル",
          text:
            "実用性がありながらデザイン性も高いeYeラインは、ジャケット、パンツ、アウターを中心に査定対象として確認します。",
        },
        {
          index: "05",
          title: "希少アーカイブ・入手困難品",
          text:
            "過去シーズンの中でも、コレクター需要が続く作品や流通量が限られるピースは、アーカイブ性を含めて判断します。",
        },
      ],
    },
    quote: {
      textLines: [
        "“人気のコラボ”としてではなく、",
        "JUNYAの設計思想が宿る服として見る。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定で、",
        "見落とされやすいJUNYAの価値。",
      ],
      intro:
        "JUNYA WATANABEは、ライン・年代・コラボレーション背景によって評価軸が大きく変わるブランドです。",
      items: [
        {
          index: "01",
          title: "JUNYA WATANABE MAN・eYe・ウィメンズを一括で見ない",
          text:
            "同じJUNYA WATANABEでも、本ライン、JUNYA WATANABE MAN、eYeでは需要の層と評価軸が異なります。ラインごとの性格を踏まえて査定します。",
        },
        {
          index: "02",
          title: "コラボ品をロゴ人気だけで判断しない",
          text:
            "相手ブランドの知名度だけでなく、JUNYA側がどのように再解釈したか、シーズン性と再流通需要まで見ます。",
        },
        {
          index: "03",
          title: "造形の強さを査定に反映する",
          text:
            "パッチワーク、再構築、異素材ミックス、独自カッティングなど、JUNYAらしさが強い服は、作品性も踏まえて確認します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。ブランドタグ、品番、コラボ先、ディテールが分かる写真があると確認しやすくなります。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。ご自身の箱または選択制の宅配キットで商品をお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・市場性・アーカイブ性を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "進めやすいJUNYA WATANABE買取。",
      ],
      intro:
        "LINEで相談してから進められるため、コラボ品やアーカイブ作品も宅配買取へ進む前に確認できます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、状態や市場性に不安がある品も事前に確認できます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "JUNYA WATANABE買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "どのJUNYA WATANABEを買取していますか？",
          answer:
            "JUNYA WATANABE、JUNYA WATANABE MAN、eYe JUNYA WATANABE MANを中心に、ジャケット、コート、デニム、パンツ、ドレス、ニット、バッグ、シューズまで幅広くご相談いただけます。",
        },
        {
          question:
            "ジュンヤワタナベマンのアイテムも査定できますか？",
          answer:
            "はい。JUNYA WATANABE MANラインのアウター、デニム、ワークウェア、コラボレーション品は特に需要を確認しながら査定します。",
        },
        {
          question:
            "eYe JUNYA WATANABE MANも買取対象ですか？",
          answer:
            "はい。eYeラインも査定対象です。ジャケット、パンツ、アウター、コラボ品などを個別に確認します。",
        },
        {
          question:
            "Levi’sやTHE NORTH FACEとのコラボも高く売れますか？",
          answer:
            "状態・型・年代・現在需要によって異なりますが、JUNYA WATANABEのコラボレーション品は中古市場でも注目度が高く、個別に評価します。",
        },
        {
          question:
            "パッチワークや再構築デザインは査定で見てもらえますか？",
          answer:
            "はい。JUNYA WATANABEの代表的な表現として、造形性・希少性・需要を確認して査定します。",
        },
        {
          question:
            "買取相場を先に知りたいです。",
          answer:
            "まずはLINEで写真をお送りください。アイテムのライン、状態、コラボ有無、需要を確認し、宅配買取へ進む前に大まかな方向性をご案内します。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "JUNYA WATANABEの価値をご相談ください。",
      ],
      body:
        "JUNYA WATANABE MAN・eYe・コラボレーション品、パッチワークや再構築まで確認。\nEnclopediaが、服の背景と再流通価値を見て宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
